 /**
 * v-hasPermi 操作权限处理
 * Copyright (c) 2019 ruoyi
 */
export default {
  inserted(el, binding, vnode) {
    const { value } = binding;
    let user = JSON.parse(sessionStorage.getItem('user'));
    const permissions = user.menus;
    if (value && value instanceof Array && value.length > 0) {
      const permissionFlag = value;

      const hasPermissions = permissions.some(permission => {
        return permissionFlag.includes(permission.menu_code)
      });

      if (!hasPermissions) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请设置操作权限标签值`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/permission/hasPermi.js